(() => {
  if (window.location.pathname === '/pages/wholesale-signup-form' || window.location.pathname === '/pages/register') {
  const intervalId = setInterval(() => {
    const form = document.querySelector('#bss-b2b-register-form');
    if (form) {
      customizeRF();
      clearInterval(intervalId);
      clearTimeout(timeoutId);
    }
  }, 200);
  
  const timeoutId = setTimeout(() => {
    clearInterval(intervalId);
  }, 8000);

  }
})();

// if (typeof BSS_B2B != 'undefined' && (window.location.pathname === '/pages/wholesale-signup-form' || window.location.pathname === '/pages/register')) {
//     document.addEventListener("DOMContentLoaded", e => {
//       const targetNode = document.querySelector('#bss-b2b-registration-form');

//       if (targetNode) {
//         const observer = new MutationObserver((mutationsList) => {
//           for (const mutation of mutationsList) {
//             if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
//               customizeRF();
//               observer.disconnect();
//             }
//           }
//         });
      
//         observer.observe(targetNode, {
//           childList: true,
//           subtree: true,
//         });
//       }
//     })
// }

function customizeRF(){  
    const form = document.querySelector("#bss-b2b-register-form");
    if (!form.classList.contains("h-adr")) {
        form.classList.add("h-adr");
        form.insertAdjacentHTML("afterbegin", '<span class="p-country-name" style="display:none;">Japan</span>');

    }
    // const email_elm = document.querySelector(".field.RegisterForm-email");
    // if (email_elm) {
    // 	const email_input = email_elm.querySelector("input");
    // 	if (email_input) {
    // 		email_input.placeholder = '例：info@exemple.jp';
    // 	}
    // }
    // const password_elm = document.querySelector(".field.RegisterForm-email");
    // const confirmEmail = document.querySelector("#bss-b2b-registration-form-render .form-group.field-text-1706693835864-0");
    // const confirmPassword = document.querySelector("#bss-b2b-registration-form-render .form-group.field-text-1706693838914-0");

    const zipCode = document.querySelector(".bss-b2b-rf-field:has(#text-field-1e3f408f46b82)");
    const address = document.querySelector("#text-field-cc370b832d3b7");
    const town = document.querySelector("#select-group-5f9cc5990c05e");
    // const streetNumber = document.querySelector(".field-text-1706078995785-0 input");
    const invoiceNumber = document.querySelector("label[for='text-field-7f89458a5f573']");
    // if (email_elm && password_elm && confirmEmail && confirmPassword) {
    // 	password_elm.after(confirmEmail);
    // }
    if (town) {
        // city.classList.add("p-locality");
        town.classList.add("p-region-id");
        // streetNumber.classList.add("p-street-address");
    }
    if (address) {
        address.classList.add("p-locality");
        address.classList.add("p-street-address");
        address.classList.add("p-extended-address");
    }
    if (invoiceNumber) {
        invoiceNumber.insertAdjacentHTML("afterend", "<div id='invoice_number' class='font-semibold'>T</div>");
    }
    if (zipCode) {
        const input = zipCode.querySelector("input");
        const messZipCode = zipCode.querySelector(".bss-message");
      
        input.classList.add("p-postal-code");
        zipCode.insertAdjacentHTML('beforeend', '<div class="portal_code_btn">郵便番号から住所を自動入力</div>');
        zipCode.appendChild(messZipCode);
        const hadr = document.querySelector(".h-adr");
        const postalcode = hadr.querySelectorAll(".p-postal-code"),
            postalField = postalcode[postalcode.length - 1];

        //イベントをキャンセル
        const onKeyupCanceller = function(e) {
            if (cancelFlag) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
            return false;
        };
        //通常の挙動をキャンセルできるようにイベントを追加
        postalField.addEventListener("keyup", onKeyupCanceller, false);
        const microformatDomInstance = new YubinBango.MicroformatDom();

        // Gọi hàm hadrloop từ đối tượng vừa tạo
        let cancelFlag = true;

        // 郵便番号の入力欄



        //ボタンクリック時
        const btn = hadr.querySelector(".portal_code_btn");
        btn.addEventListener("click", function(e) {
            //キャンセルを解除
            cancelFlag = false;

            //処理実行
            let event;
            if (typeof Event === "function") {
                event = new Event("keyup");
            } else {
                event = document.createEvent("Event");
                event.initEvent("keyup", true, true);
            }
            postalField.dispatchEvent(event);

            //キャンセルを戻す
            cancelFlag = true;
        });
    }

    //該当フォーム
    const password_wraper = document.querySelector("#bss-b2b-registration-form-render");
    const label = document.querySelector("label[for='text-1706693838914-0']");
    if (password_wraper) {
        password_wraper.insertAdjacentHTML("afterbegin", '<label bis_skin_checked="1" id="password-label">パスワード <span class="formbuilder-required">必須</span></label>');

    }
    // if(label){
    //   label.innerHTML = 'パスワード(確認)';
    // }

    const password_field = document.querySelector(".password-field");
    if (password_field) {
        const render_form = document.querySelector("#bss-b2b-registration-form-render .rendered-form");
        if (render_form) {
            render_form.prepend(password_field);
        }
    }

    const header = document.querySelector(".bss-b2b-registration-form-title");
    if(header){
        const h1 = header.querySelector("h1");
        if(h1) h1.innerHTML = '新規登録';
        header.insertAdjacentHTML('beforeend','<span class="sub-header">当サイトは業務用としてご利用になる法人様 飲食店・販売店、または飲食業に所属している個人の方を対象にしています。それ以外の方のご利用は出来ませんのでご了承ください。</span>')
    }
    const submit_btn = document.querySelector("#bss-b2b-register-form input[type='submit']");
    if (submit_btn) {
        submit_btn.insertAdjacentHTML('afterend', '<span>弊社より2営業日以内に登録された電話番号にご連絡を入れ、入力された情報を確認させていただきます。弊社で確認後、本登録を行い、登録のメールアドレスに登録完了のお知らせが届きます。その後、ログインされましたら、 業務用価格 限定商品が見れるようになり、ご注文いただけます。</span>')
    }

    // const first_name = document.querySelector('#bss-b2b-register-form .field #bss-b2b-register-form-FirstName');
    // if(first_name){
    //   first_name.placeholder = '例：山田太郎';
    // }

    const firstName = document.querySelector(".field:has(#bss-b2b-register-form-FirstName)");
    const lastName = document.querySelector(".field.RegisterForm-LastName");
    if (firstName && lastName) {
        lastName.after(firstName);
    }
    // const phoneField = document.querySelector('.formbuilder-text.form-group.field-text-1713427331532-0');
    // const nameField = document.querySelector('.field label[for="RegisterForm-FirstName"]').closest('.field');
    // if (phoneField && nameField) {
    //     nameField.parentNode.insertBefore(phoneField, nameField.nextSibling);
    // }
  
    try{
      const fields = document.querySelectorAll(".bss-b2b-rf-field:not(.field-privacy-policy)");
      fields.forEach(field => {
          const label = field.querySelector("#invoice_number")  || field.querySelector("label"); 
        const input = field.querySelector("select") || field.querySelector("input");
        const mess = field.querySelector(".bss-message");
      
        if (input && mess) {
          const wrapper = document.createElement("div");
          wrapper.className = "group";
      
          wrapper.appendChild(input);
          wrapper.appendChild(mess);
          if(label && label.nextSibling) {
              field.insertBefore(wrapper, label.nextSibling);
          }
        }

        const targetContainer = document.querySelector('.field-password .group');
        
        const policy = document.querySelector(".field-privacy-policy");
        const repass = document.querySelector(".bss-b2b-rf-field:has([for=text-field-73615b80a67b2])");
        const hideShowPass = document.querySelector(".password-input");
        
        if (targetContainer) {
            const label = document.createElement('label');
            label.setAttribute('for', 'RegisterForm-password');
            label.textContent = 'パスワード';
            if(!targetContainer.querySelector("label[for='RegisterForm-password']")) {
              targetContainer.insertBefore(label, targetContainer.firstChild);
            }
            
          if (hideShowPass) targetContainer.appendChild(hideShowPass);
          if (repass) {
            targetContainer.appendChild(repass);
            repass.querySelector("input").type = 'password';
          }
          if (policy) targetContainer.appendChild(policy);
        }
      });
    } catch(e) {}

    //set default country field to JP
    document.querySelector("#country-list li[value='JP']").click();
    // const country_field = document.querySelector(".field-country-field");
    // if (country_field) {
    //     const country = country_field.querySelector("#country-field-input");
    //     const country_code = country_field.querySelector("#country-field");
    //     if (country) {
    //         country.value = 'Japan'
    //     }
    //     if (country_code) {
    //         country_code.value = 'JP'
    //     }
    // }
  // const cf_email = document.querySelector(`[name="text-field-4e8a8aad8b86f"]`);
  // if(cf_email) {
  //   cf_email.setAttribute("name", "");
  // }
  // const cf_pass = document.querySelector(`[name="text-field-73615b80a67b2"]`);
  // if(cf_pass) {
  //   cf_pass.setAttribute("name", "");
  // }

  const hiddenPhone = document.querySelector("#phone-country-code");
  const phone = document.querySelector("div:has(>.phone-country-select-wrapper");
  if(hiddenPhone && phone) {
      hiddenPhone.after(phone)
  }

  // translate State by KC
  const dataState = {
	'Hokkaido': {
		value: '北海道',
		state: '北海道'
	},
	'Aomori': {
		value: '青森県',
		state: '青森県'
	},
	'Iwate': {
		value: '岩手県',
		state: '岩手県'
	},
	'Miyagi': {
		value: '宮城県',
		state: '宮城県'
	},
	'Akita': {
		value: '秋田県',
		state: '秋田県'
	},
	'Yamagata': {
		value: '山形県',
		state: '山形県'
	},
	'Fukushima': {
		value: '福島県',
		state: '福島県'
	},
	'Ibaraki': {
		value: '茨城県',
		state: '茨城県'
	},
	'Tochigi': {
		value: '栃木県',
		state: '栃木県'
	},
	'Gunma': {
		value: '群馬県',
		state: '群馬県'
	},
	'Saitama': {
		value: '埼玉県',
		state: '埼玉県'
	},
	'Chiba': {
		value: '千葉県',
		state: '千葉県'
	},
	'Tokyo': {
		value: '東京都',
		state: '東京都'
	},
	'Kanagawa': {
		value: '神奈川県',
		state: '神奈川県'
	},
	'Niigata': {
		value: '新潟県',
		state: '新潟県'
	},
	'Toyama': {
		value: '富山県',
		state: '富山県'
	},
	'Ishikawa': {
		value: '石川県',
		state: '石川県'
	},
	'Fukui': {
		value: '福井県',
		state: '福井県'
	},
	'Yamanashi': {
		value: '山梨県',
		state: '山梨県'
	},
	'Nagano': {
		value: '長野県',
		state: '長野県'
	},
	'Gifu': {
		value: '岐阜県',
		state: '岐阜県'
	},
	'Shizuoka': {
		value: '静岡県',
		state: '静岡県'
	},
	'Aichi': {
		value: '愛知県',
		state: '愛知県'
	},
	'Mie': {
		value: '三重県',
		state: '三重県'
	},
	'Shiga': {
		value: '滋賀県',
		state: '滋賀県'
	},
	'Kyoto': {
		value: '京都府',
		state: '京都府'
	},
	'Osaka': {
		value: '大阪府',
		state: '大阪府'
	},
	'Hyogo': {
		value: '兵庫県',
		state: '兵庫県'
	},
	'Nara': {
		value: '奈良県',
		state: '奈良県'
	},
	'Wakayama': {
		value: '和歌山県',
		state: '和歌山県'
	},
	'Tottori': {
		value: '鳥取県',
		state: '鳥取県'
	},
	'Shimane': {
		value: '島根県',
		state: '島根県'
	},
	'Okayama': {
		value: '岡山県',
		state: '岡山県'
	},
	'Hiroshima': {
		value: '広島県',
		state: '広島県'
	},
	'Yamaguchi': {
		value: '山口県',
		state: '山口県'
	},
	'Tokushima': {
		value: '徳島県',
		state: '徳島県'
	},
	'Kagawa': {
		value: '香川県',
		state: '香川県'
	},
	'Ehime': {
		value: '愛媛県',
		state: '愛媛県'
	},
	'Kochi': {
		value: '高知県',
		state: '高知県'
	},
	'Fukuoka': {
		value: '福岡県',
		state: '福岡県'
	},
	'Saga': {
		value: '佐賀県',
		state: '佐賀県'
	},
	'Nagasaki': {
		value: '長崎県',
		state: '長崎県'
	},
	'Kumamoto': {
		value: '熊本県',
		state: '熊本県'
	},
	'Oita': {
		value: '大分県',
		state: '大分県'
	},
	'Miyazaki': {
		value: '宮崎県',
		state: '宮崎県'
	},
	'Kagoshima': {
		value: '鹿児島県',
		state: '鹿児島県'
	},
	'Okinawa': {
		value: '沖縄県',
		state: '沖縄県'
	}
}
  const stateElement = document.querySelectorAll("#state-field option");
  if(stateElement && stateElement.length > 0) {
    stateElement.forEach(item => {
      const data = dataState[item.innerText];
      item.value = data.value;
      item.innerText = data.state;
    })
  }
}